import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Flex, Link } from '@chakra-ui/react'
import { FaExternalLinkAlt, FaFilePdf } from 'react-icons/fa'
import { Navigate } from 'react-router-dom'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { parseJwt } from '../../../services/token'
import { Body } from '../../Layouts/Body'

const urlBlob = 'https://sigah.blob.core.windows.net/assets/2026/'

const modulos = [
  {
    nome: 'Cargos e Salários',
    documentos: [
      { titulo: 'Guia de criação de descrição de cargo', url: `${urlBlob}Guia%20de%20Cria%C3%A7%C3%A3o%20de%20Descricao%20de%20Cargo.rev01MA.pdf` }
    ]
  },
  {
    nome: 'Desempenho',
    documentos: [
      { titulo: 'Manual de reenvio e exclusão de avaliados na pesquisa de desempenho', url: `${urlBlob}Manual_Reenvio_e_exclusao_de_avaliados_pesquisa_desempenho_rev02MA.pdf` },
      { titulo: 'Pesquisas quantitativa e indicativa', url: `${urlBlob}SAH%20-%20Pesquisas%20Quantitativa%20e%20Indicativa.rev02MA.pdf` }
    ]
  },
  {
    nome: 'Engajamento',
    documentos: [
      { titulo: 'Manual de pesquisas de engajamento', url: `${urlBlob}Manual_de_Pesquisas_Engajamento_SAH.rev01MA.pdf` }
    ]
  },
  {
    nome: 'Configurações gerais',
    documentos: [
      { titulo: 'Permissões e níveis de acesso', url: `${urlBlob}SAH%20-%20Permiss%C3%B5es%20e%20N%C3%ADveis%20de%20Acesso.rev01MA.pdf` }
    ]
  }
]

export const DocumentosApoio: React.FC = () => {
  if (parseJwt().adm !== 'True') {
    return <Navigate to='/Colaborador' />
  }

  return (
    <Body>
      <h2>Documentos de Apoio</h2>
      <WhiteContainer margin='1rem 0'>
        <Accordion allowMultiple display='flex' flexDir='column' gap='.75rem'>
          {modulos.map(modulo => (
            <AccordionItem key={modulo.nome} border='1px solid #E2E8F0' borderRadius='.5rem' overflow='hidden'>
              <AccordionButton bg='white' color='black' py='.9rem' px='1.25rem' _hover={{ bg: '#F7F8FA' }} _expanded={{ bg: '#F7F8FA', borderBottom: '1px solid #E2E8F0' }}>
                <Box flex='1' textAlign='left' fontWeight='600' fontSize='1rem' color='black'>{modulo.nome}</Box>
                <Box fontSize='.8rem' color='#718096' mr='.75rem'>
                  {modulo.documentos.length} {modulo.documentos.length === 1 ? 'documento' : 'documentos'}
                </Box>
                <AccordionIcon color='black' />
              </AccordionButton>
              <AccordionPanel p='.5rem' bg='white'>
                {modulo.documentos.map(documento => (
                  <Link
                    key={documento.url}
                    href={documento.url}
                    isExternal
                    display='flex'
                    alignItems='center'
                    gap='.75rem'
                    px='.75rem'
                    py='.65rem'
                    borderRadius='.375rem'
                    color='black'
                    fontSize='.95rem'
                    _hover={{ bg: '#F7F8FA', textDecoration: 'none' }}
                  >
                    <Flex alignItems='center' justifyContent='center' minW='2rem' h='2rem' borderRadius='.375rem' bg='#FDECEC' color='#E53E3E'>
                      <FaFilePdf />
                    </Flex>
                    <Box flex='1'>{documento.titulo}</Box>
                    <FaExternalLinkAlt size={12} color='#718096' />
                  </Link>
                ))}
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </WhiteContainer>
    </Body>
  )
}
